export default "__VITE_ASSET__Co$DsnEN__"